import type { ReactNode } from "react";
import "./empty-state.css";

export interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  primaryAction?: ReactNode;
  secondaryAction?: ReactNode;
}

export function EmptyState({
  icon,
  title,
  description,
  primaryAction,
  secondaryAction,
}: EmptyStateProps) {
  return (
    <div className="wp-empty">
      {icon ? <div className="wp-empty__icon" aria-hidden="true">{icon}</div> : null}
      <h2 className="wp-empty__title">{title}</h2>
      {description ? <p className="wp-empty__desc">{description}</p> : null}
      {primaryAction || secondaryAction ? (
        <div className="wp-empty__actions">
          {primaryAction}
          {secondaryAction}
        </div>
      ) : null}
    </div>
  );
}
